module.exports = __webpack_public_path__ + "img/Feuerwehrgerätehaus.02affd51.svg";